import { create } from "zustand";

interface NotificationStore {
  notifications: any[];
  notRemovedNotifications: any[];
  userMessagesNotification: any[];
  isMessagesSheetOpen: boolean;
  selectedConversationId: string | null;
  unReadCounter: number;
  userNotification: {
    type: string | null;
    normal_user: string | null;
    conversation_id: string | null;
  };
  setIsMessagesSheetOpen: (open: boolean) => void;
  setSelectedConversationId: (id: string | null) => void;
  addNotification: (notification: any) => void;
  addNotRemovedNotifications: (notification: any) => void;
  addUserMessagesNotification: (userMessagesNotification: any) => void;
  addUserNotification: (userMessagesNotification: any) => void;
  removeAllNotifications: () => void;
  removeSupportNotifications: () => void;
  addUnReadCounter: () => void;
}

const useNotificationStore = create<NotificationStore>((set, get) => ({
  notifications: [],
  userMessagesNotification: [],
  notRemovedNotifications: [],
  unReadCounter: 0,
  userNotification: {
    conversation_id: null,
    normal_user: null,
    type: null
  },
  isMessagesSheetOpen: false,
  selectedConversationId: null,
  addNotification: (notification) =>
    set((state) => ({
      notifications: [...state.notifications, notification]
    })),
  addNotRemovedNotifications: (notification) =>
    set((state) => ({
      notRemovedNotifications: [...state.notRemovedNotifications, notification]
    })),
  addUserMessagesNotification: (userMessagesNotification) =>
    set((state) => ({
      userMessagesNotification: [
        ...state.userMessagesNotification,
        userMessagesNotification
      ]
    })),
  addUserNotification: (userNotification) =>
    set((state) => ({
      userNotification: userNotification
    })),
  addUnReadCounter : () =>
    set((state) => ({
      unReadCounter:  state.unReadCounter + 1
    })),
  removeAllNotifications: () => set({ notifications: [] }),
  removeSupportNotifications: () => set({ userMessagesNotification: [] }),
  setIsMessagesSheetOpen: (open) => set({ isMessagesSheetOpen: open }),
  setSelectedConversationId: (id) => set({ selectedConversationId: id })
}));

export default useNotificationStore;
